import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AdminComponent} from './admin.component';
import {AdminResolver} from './admin-resolver';
import {LoggedInGuard} from '../login/logged-in.guard';
import {ShipmentResolver} from './shipment/shipment-details/shipment-resolver';
import {ShipmentDetailsComponent} from './shipment/shipment-details/shipment-details.component';
import {AllShipmentListResolver} from './shipment/all-shipments/all-shipment-list-resolver';
import {AllShipmentsComponent} from './shipment/all-shipments/all-shipments.component';
import {DeviatedShipmentListComponent} from './shipment/deviated-shipment-list/deviated-shipment-list.component';
import {DeviatedShipmentListResolver} from './shipment/deviated-shipment-list/deviated-shipment-list-resolver';
import {UserListComponent} from './user/user-list/user-list.component';
import {UserListResolver} from './user/user-list/user-list-resolver';
import {DeviationDefinitionListComponent} from './deviation-definition/deviation-definition-list/deviation-definition-list.component';
import {DeviationDefinitionListResolver} from './deviation-definition/deviation-definition-list/deviation-definition-list-resolver';
import {AttachmentListComponent} from '../component/attachment-list/attachment-list.component';
import {AssignOrderCarrierComponent} from './shipment/assign-carrier-dialog/assign-order-carrier.component';
import {AssignShipmentsComponent} from './shipment/assign-shipments/assign-shipments.component';
import {AssignShipmentsListResolver} from './shipment/assign-shipments/assign-shipments-list-resolver';
import {AssignOrdersComponent} from './order/assign-orders/assign-orders.component';
import {OrderAssignListResolver} from './order/assign-orders/order-assign-list-resolver.service';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'admin',
        component: AdminComponent,
        resolve: {data: AdminResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'admin/orders',
        component: AssignOrdersComponent,
        resolve: {data: OrderAssignListResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'admin/shipments',
        component: AllShipmentsComponent,
        resolve: {shipments: AllShipmentListResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'admin/shipments/deviated',
        component: DeviatedShipmentListComponent,
        resolve: {data: DeviatedShipmentListResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'admin/shipments/assign',
        component: AssignShipmentsComponent,
        resolve: {shipments: AssignShipmentsListResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'admin/shipment/:query',
        component: ShipmentDetailsComponent,
        resolve: {shipment: ShipmentResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'admin/users',
        component: UserListComponent,
        resolve: {data: UserListResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'admin/deviation/definitions',
        component: DeviationDefinitionListComponent,
        resolve: {data: DeviationDefinitionListResolver},
        data: {showMenu: true},
        runGuardsAndResolvers: 'always',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'attachments',
        component: AttachmentListComponent,
        runGuardsAndResolvers: 'always',
        outlet: 'popup',
        canActivate: [LoggedInGuard]
      },
      {
        path: 'assign/:orderId',
        component: AssignOrderCarrierComponent,
        outlet: 'popup',
        canActivate: [LoggedInGuard]
      }
    ])
  ],
  exports: [
    RouterModule
  ]
})
export class AdminRoutingModule {
}
